const Enums = {
    customerType: ['Retail_Sale_Walk_In', 'Tenant_With_Ledger'],
    action: ['Add', 'Increment', 'Clear', 'Clear_All', 'Restocked'],
    source: ['Post_Move_In', 'Post_Move_In_Responsive'],
};

export default Enums;
